import React, { Component } from "react";
import "./ChangePassword.css";
import MMCL_Logo from "../static/images/MMCL_Logo.webp";
import { toast } from "react-toastify";
import axios from "../api/axios";
import hideElements from '../utility/Tools.js';
import ValidateEmail from "./custom_validations/ValidateEmailCheck.js";
function sendPasswordToEmail(){
  if(document.getElementById('validEmailText').style.color==='green'){
    var ForgetPass_url="forgetpass/"+document.getElementById('inputEmail').value;
    axios.get(ForgetPass_url)
    hideElements();
    toast.success('Email has been successfully sent.', {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
    });
    //Put timer for redirection of page
    setTimeout(function () {
      window.location.href = '/sign-in';
  }, 5000);
  }
}

export class ChangePasswordEmail extends Component {
  static displayName = ChangePasswordEmail.name;

  componentDidMount(){
    document.getElementById("inputEmail").addEventListener("keypress", function(event){
      if(event.key==="Enter"){
        event.preventDefault();
        document.getElementById("btnChangePass").click();
      }
  })
}

  render() {
    return (
      <div className="change-password">
            <div className="card change-password-card">
          <form>
            <div className="change-password-logo-container text-center">
              <img src={MMCL_Logo} className="change-password-logo" alt="MMCL Logo" />
            </div>
            <h3 id="changePasswordEmailHeader" className="text-center mt-10 b-10">Enter your registered email address.</h3>
            <p id="changePasswordEmailText" class="text-center mt-5 mb-5">An email will be sent to your email address to allow you to change your password.</p>
            <div className="form-outline mb-4 hiding-elements">
              <label className="form-label" for="inputEmail">
                Email address
              </label>
              <input type="email" id="inputEmail" className="form-control" onChange={ValidateEmail}/>
            </div>
            <div id="emailRequirements" style={{ display: "none" }} className="resend-email-email-requirement hiding-elements">
              <li id="validEmailText">✕ Must be a valid email!</li>
              <br/>
            </div>
            <div className="text-center hiding-elements">
              <button
                id="btnChangePass"
                type="button"
                className="btn btn-block mb-4 sign-in-button"
                onClick={() => sendPasswordToEmail()}
              >
                Submit
              </button>
            </div>
          </form>
        </div>
      </div>
    );
  }
}
